export const DICTIONARY_LANGUAGES = {
  ZH: {
    name: "zh",
    displayName: "dictionary_chinese_tab_label",
  },
  EN: {
    name: "en",
    displayName: "dictionary_english_tab_label",
  },
  TA: {
    name: "ta",
    displayName: "dictionary_tamil_tab_label",
  },
  MS: {
    name: "ms",
    displayName: "dictionary_malay_tab_label",
  },
};
